<div class="g2r-header">
  <div class="g2r-header-left">
    <div class="g2r-logo">G2</div>
    <div>
      <h2 mat-dialog-title class="g2r-title">Review Form</h2>
      <p class="g2r-subtitle">Share your experience with the WMS community</p>
    </div>
  </div>
  <button class="g2r-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<iframe
  [src]="safeUrl"
  class="g2-iframe"
  frameborder="0"
  allow="clipboard-write"
  title="G2 Review Form">
</iframe>
